module.exports = __webpack_public_path__ + "static/media/26_plantilla_navidad_combo_duo_rec_cinta_1_motivo_1.659abc81.png";